import { NetworkForAllMembersType } from './types';

export const getNetworkByUserId = (networkForAllMembers: NetworkForAllMembersType, userId: Nullable<number>) => {
  if (!userId) {
    return undefined;
  }

  return networkForAllMembers.patients?.find?.((patient) => userId === patient.user_id);
};
